import { WarningOutlined } from '@ant-design/icons';
import React from 'react';

export function SeriousDeleteQuestion({ firstText, mainNotice, lastText }) {
  return (
    <article className="meteo-station-delete-modal">
      <p>{firstText}</p>
      <div className="meteo-station-delete-modal-message">
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <WarningOutlined />
          <p>{mainNotice}</p>
        </div>
      </div>
      <p>{lastText}</p>
    </article>
  );
}
